import { useEffect, useMemo, useState } from 'react';

import config from 'config';

const DEFAULT_STATUS = {
  loading: true,
  isMaintenanceMode: false,
  title: '',
  message: ''
};

const buildStatusUrl = (applicationName) => {
  const endpoint = config.graphqlUrl || 'http://localhost:5001/graphql';

  try {
    const url = new URL(endpoint);
    const normalizedPath = url.pathname.replace(/\/graphql\/?$/i, `/app-status/${applicationName}`);
    url.pathname = normalizedPath;
    return url.toString();
  } catch (error) {
    const sanitized = endpoint.replace(/\/graphql\/?$/i, '');
    return `${sanitized}/app-status/${applicationName}`;
  }
};

const REFRESH_INTERVAL =  3_600_000; // 1 hour

const useMaintenanceGate = (applicationName = 'portal-fe') => {
  const [status, setStatus] = useState(DEFAULT_STATUS);
  const statusUrl = useMemo(() => buildStatusUrl(applicationName), [applicationName]);

  useEffect(() => {
    let isCancelled = false;
    const fetchStatus = async () => {
      try {
        const response = await fetch(statusUrl, {
          method: 'GET',
          headers: {
            Accept: 'application/json'
          }
        });

        if (!response.ok) {
          throw new Error(`Failed to load maintenance status (${response.status})`);
        }

        const data = await response.json();
        if (!isCancelled) {
          setStatus({
            loading: false,
            isMaintenanceMode: Boolean(data.isMaintenanceMode),
            title: data.title || 'Scheduled maintenance',
            message: data.message || 'We are performing a short update. Thanks for your patience.'
          });
        }
      } catch (error) {
        console.warn('[MaintenanceGate] Unable to load status', error);
        if (!isCancelled) {
          setStatus((prev) => ({
            ...prev,
            loading: false
          }));
        }
      }
    };

    fetchStatus();

    const intervalId = setInterval(fetchStatus, REFRESH_INTERVAL);

    return () => {
      isCancelled = true;
      clearInterval(intervalId);
    };
  }, [statusUrl]);

  return status;
};

export default useMaintenanceGate;


